<template>
  <div class="market-login-auth">
    <div class="market-login-auth__heading">
      <h1>企业登录</h1>
      <p>请输入账号密码，或使用短信验证码登录。</p>
    </div>

    <a-tabs class="market-login-auth__tabs" default-active-key="user" @change="handleTabCallback">
      <a-tab-pane key="user" tab="账号登录">
        <user-login v-if="isShowUser"></user-login>
      </a-tab-pane>
      <a-tab-pane key="mobile" tab="短信登录" force-render>
        <mobile-login v-if="isShowMobile"></mobile-login>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import MobileLogin from './components/MobileLogin';
import UserLogin from './components/UserLogin';

export default {
  name: 'StoreLogin',
  components: {
    UserLogin,
    MobileLogin
  },
  data() {
    return {
      isShowUser: true,
      isShowMobile: false
    };
  },
  methods: {
    handleTabCallback(e) {
      if (e === 'mobile') {
        this.isShowUser = false;
        this.isShowMobile = true;
      } else {
        this.isShowUser = true;
        this.isShowMobile = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import 'src/styles/login-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/login/storeLogin.vue